module.exports = __webpack_public_path__ + "dimer/static/img/MrTJing.c572c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MrTJing.jpg
// module id = 4SKx
// module chunks = 0